//
// Start of Selection
import { useQueryClient } from "@tanstack/react-query";
import { journalsQueries } from "@entities/journal";
import { $journalApi } from "@entities/journal/fetch/fetch-client.ts";

type Participants =
  | "developer"
  | "technicalCustomer"
  | "projectDocumentationContractor"
  | "buildingContractor";

type MultipleParticipants = "designerSupervisions" | "otherDevelopers";

export function useDeleteParticipant({ titleId }: { titleId: string }) {
  const queryClient = useQueryClient();
  const mutation = $journalApi.useMutation(
    "delete",
    "/api/v1/journals/title/{titleId}/companiesParticipants",
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: journalsQueries.getTitleJournal({ titleId }).queryKey,
        });
      },

    },
  );

  return {
    ...mutation,
    mutate: <T extends Participants | MultipleParticipants>({
      projectParticipantId,
      participantType,
      listId,
      mutateOptions,
    }: {
      projectParticipantId: T extends MultipleParticipants ? string[] : string;
      participantType: T;
      listId?: string;
      mutateOptions?: {
        onSuccess?: () => void;
        onError?: () => void;
        onSettled?: () => void;
      };
    }) => {
      const isMultiple =
        participantType === "otherDevelopers" ||
        participantType === "designerSupervisions";

      const requestBody = {
        [participantType]: isMultiple
          ? (projectParticipantId as string[]).map((id) => ({
              projectParticipantId: id,
              ...(listId ? { listId } : {}),
            }))
          : {
              projectParticipantId,
              ...(listId ? { listId } : {}),
            },
      };

      mutation.mutate(
        {
          params: {
            path: {
              titleId,
            },
          },
          body: requestBody,
        },
        mutateOptions,
      );
    },
  };
}
